import React from "react";
import "./webinarLandingPage.css";

const WebinarThanku = () => {
  return (
    <div className="thankyou-container">
      <div className="thankyou-card">
        <h1 className="thankyou-title">🙏 धन्यवाद!</h1>
        <p className="thankyou-subtitle">
          मायओमनमो पितृपक्ष वेबिनारसाठी नोंदणी केल्याबद्दल आभारी आहोत.
        </p>

        <div className="thankyou-details">
          <h2>📌 वेबिनार माहिती</h2>
          <ul>
            <li><strong>दिनांक:</strong> ७ सप्टेंबर २०२५</li>
            <li><strong>वेळ:</strong> सकाळी १० ते ११:३०</li>
            <li><strong>कालावधी:</strong> १:३० तास</li>
            <li><strong>भाषा:</strong> मराठी</li>
            <li><strong>प्लॅटफॉर्म:</strong> झूम</li>
            <li><strong>शुल्क:</strong> ₹५१</li>
          </ul>
        </div>

        <div className="thankyou-note">
          <p>✅ हा कार्यक्रम चुकवू नये म्हणून तो तुमच्या कॅलेंडरमध्ये जोडा.</p>
          <p>
            📧 कार्यक्रमाच्या तारखेच्या जवळ तुम्हाला वेबिनारसाठी सामील होण्यासाठीची
            झूम मीटिंग लिंक असलेला स्वतंत्र ईमेल मिळेल.
          </p>
        </div>
      </div>
    </div>
  );
};

export default WebinarThanku;
